/* GUTTER TM shop behaviour. Progressive only: everything here also works without it.
   1. form[data-auto] (sort select, filter checkboxes and price fields) submits itself on change,
      so the APPLY buttons ([data-js-hide]) are hidden while JS runs.
   2. tr[data-act="row"][data-href] (INDEX table) opens the product on click, like the prototype;
      the name cell is a real link, so clicks on it are left alone.
   The hover peek on [data-peek] is handled by base.js. */
(function (w, d) {
  "use strict";

  function onChange(e) {
    var form = e.target.closest ? e.target.closest("form[data-auto]") : null;
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  }

  function onClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.target.closest && e.target.closest("a, button, input, label")) return;
    var row = e.target.closest ? e.target.closest('[data-act="row"]') : null;
    if (!row) return;
    var href = row.getAttribute("data-href");
    if (href) w.location.href = href;
  }

  function boot() {
    var hide = d.querySelectorAll("[data-js-hide]");
    for (var i = 0; i < hide.length; i++) hide[i].hidden = true;
    d.addEventListener("change", onChange);
    d.addEventListener("click", onClick);
  }

  if (d.readyState === "loading") d.addEventListener("DOMContentLoaded", boot); else boot();
})(window, document);
